export default __webpack_public_path__ + "static/media/loader.86e365cf.svg";